/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./listRepos.defs.js";
export { main as default } from "./listRepos.defs.js";
